import { Box } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

export const BannerWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(7, 0, 3, 0),
}));
